module.exports = __webpack_public_path__ + "img/a7_01.9635263d.jpg";